/**
 * Telegram Mini App SDK initialization
 * 
 * Based on @tma.js/sdk-react official template
 */
import {
  setDebug,
  themeParams,
  initData,
  viewport,
  init as initSDK,
  miniApp,
  backButton,
} from '@tma.js/sdk-react';

export interface InitOptions {
  debug?: boolean;
}

/**
 * Initialize the Telegram Mini App SDK and mount all required components
 */
export async function init(options: InitOptions = {}): Promise<void> {
  // Set debug mode
  if (options.debug) {
    setDebug(true);
  }

  // Initialize the SDK
  initSDK();

  // Mount components
  backButton.mount.ifAvailable();
  initData.restore();

  if (miniApp.mount.isAvailable()) {
    themeParams.mount();
    miniApp.mount();
    miniApp.ready();
    themeParams.bindCssVars();
  }

  if (viewport.mount.isAvailable()) {
    viewport.mount()
      .then(() => viewport.bindCssVars())
      .catch((error) => {
        console.warn('[Init] viewport mount failed', error);
      });
  }
}
